export default {
	office_address: {
		title: 'Office Address',
		address: '39 Namdaemun-Ro, Jung District, Seoul, South Korea.',
	},
	connect: {
		title: 'Connect With Us',
		phone: {
			label: '+82 2-852-2548',
			alt: 'Phone call icon',
		},
		whatsapp: {
			label: '+82 2-852-2548',
			alt: 'WhatsApp icon',
		},
		email: {
			support: 'support[at]jpworldpay.com',
			info: 'info[at]jpworldpay.com',
			alt: 'Email icon',
		},
	},
	navigation: {
		individual: {
			title: 'Individual',
			menu_items: {
				online_shopping: 'Online Shopping',
				offline_kiosk: 'Offline Kiosk',
				pay_with_qr: 'Pay With QR Code',
				transaction_cashback: 'Transaction & Cashback',
				send_asset: 'Send Asset',
				asset_request: 'Asset Request',
				get_deposit: 'Get A Deposit',
				fee: 'Fee',
				wallet: 'Wallet',
				account: 'Account',
				sell: 'Sell',
				exchanging_currency: 'Exchanging Currency',
			},
		},
		business: {
			title: 'Business',
			menu_items: {
				getting_started: 'Getting Started',
				accepting_payment: 'Accepting Payment',
				make_payment: 'Make A Payment',
				risk_management: 'Risk Management',
				about_company: 'About Company',
				platforms_features: 'Platforms & Features',
				payment_method: 'Payment Method',
				global_payment: 'Global Payment',
				global_processing: 'Processing',
			},
		},
		other_links: {
			title: 'Other Links',
			menu_items: {
				about: 'About JPWorldPay',
				get_deposit: 'Get a deposit',
				development: 'Development',
				customer_service: 'Customer Service',
				testimonial: 'Testimonial',
				contact: 'Contact Us',
			},
		},
		terms_policy: {
			title: 'Terms & Policy',
			menu_items: {
				privacy: 'Privacy Policy',
				cookies: 'Cookies Policy',
				terms: 'Terms & Conditions',
			},
		},
	},
	social_media: {
		title: 'Follow Us',
		platforms: {
			facebook: {
				label: 'Facebook',
				alt: 'Facebook icon',
			},
			twitter: {
				label: 'Twitter',
				alt: 'Twitter icon',
			},
			linkedin: {
				label: 'LinkedIn',
				alt: 'LinkedIn icon',
			},
			youtube: {
				label: 'YouTube',
				alt: 'YouTube icon',
			},
		},
	},
	copyright: {
		text: "{'ⓒ'} JP WORLD Pay. All Rights Reserved.",
	},
	accessibility: {
		logo_alt: 'JPWorldPay Footer Logo',
	},

	footermob: {
		main_head: 'Connect With Us',
		mail1: 'support[at]jpworldpay.com',
		mail2: 'info[at]jpworldpay.com',
		individual: {
			title: 'Individual',
			list1: 'Online Shopping',
			list2: 'Offline Kiosk',
			list3: 'Pay With QR Code',
			list4: 'Transaction & Cashback',
			list5: 'Send Asset',
			list6: 'Asset Request',
			list7: 'Get A Deposit',
			list8: 'Fee',
			list9: 'Get A Wallet',
			list10: 'Account',
			list11: 'Sell',
			list12: 'Exchanging Currency',
		},
		business: {
			title: 'Business',
			list1: 'Getting Started',
			list2: 'Accepting Payment',
			list3: 'Make A Payment',
			list4: 'Risk Management',
			list5: 'About Company',
			list6: 'Platforms & Features',
			list7: 'Payment Method',
			list8: 'Global Payment Processing',
		},
		OtherLinks: {
			title: 'Other Links',
			list1: 'About JPWorldPay',
			list2: 'Get a deposit',
			list3: 'Development',
			list4: 'Customer Service',
			list5: 'Testimonial',
			list6: 'Contact Us',
		},
		terms: {
			title: 'Terms & Policy',
			list1: 'Privacy Policy',
			list2: 'Cookies Policy',
			list3: 'Terms & Conditions',
		},
	},
};
